import { Component, Input, OnInit } from '@angular/core';
import { Settings, AppSettings } from 'src/app/app.settings';
import { AppService } from 'src/app/app.service';  
import { MenuItem } from 'src/app/app.models';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';
import { HostService } from 'src/app/services/host.service';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ArticlesService } from 'src/app/services/articles.service';
import { ArticleInterface } from './articles';
import { Router } from '@angular/router';


@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {

  @Input("carinput") carinput: Array<any> = [];
  public config2: SwiperConfigInterface = {};
  public config3: SwiperConfigInterface = {};
  public config4: SwiperConfigInterface = {};
  public config: SwiperConfigInterface = {};

  public slides = [];
  public menuItems: MenuItem[] = [];
  public myInputMessage: any;
  public settings: Settings;
  public articles:ArticleInterface[]=[];

  public defaultImage:string;
 

  constructor(
    public appSettings: AppSettings,
    public appService: AppService,
    public car: VehiculeserviceService,
    public getHost:HostService,
    public articleService:ArticlesService,
    public router:Router
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit(): void {
    this.defaultImage= this.getHost.getHttpsImage()+'images/others/actuality.jpg'
    this.getMenuItems();
    this.getArticles();
  }

  public getArticles() {
    this.articleService.getArticles().subscribe((res:any)=>{
      this.articles =res.articles;
      console.log(this.articles);
    })
  }

  public getMenuItems() {

    this.car.getallcar().subscribe((data: any) => {
      this.myInputMessage = data;
      this.menuItems = data;
      // console.log(this.menuItems, data);
    });
  }

  ngAfterViewInit(){

    this.config = {
      observer: true,
      slidesPerView: 8,
      spaceBetween: 8,       
      keyboard: true,
      navigation: { nextEl: '.prop-next', prevEl: '.prop-prev'},
      //pagination: true,
      autoplay:true,
      speed:700,
      effect:'slide',
      grabCursor: true,        
      loop: false,
      preloadImages: false,
      lazy: true,   
      breakpoints: {
        280: {
          slidesPerView: 1
        },
        600: {
          slidesPerView: 2
        },
        960: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 4
        }
      }
    }

    this.config3 = {
      observer: true,
      slidesPerView: 3,
      spaceBetween: 1,       
      keyboard: true,
      
      //navigation: { nextEl: '.prop-next', prevEl: '.prop-prev'},
      //pagination: true,
      autoplay:true,
      grabCursor: true,        
      loop: false,
      preloadImages: false,
      lazy: true,   
      breakpoints: {
        1280: {
          slidesPerView: 1
        },
        960: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 3
        }
      }
    }

    this.config2 = {
      observer: true,
      slidesPerView: 8,
      spaceBetween: 8,       
      keyboard: true,
      navigation: { nextEl: '.prop-next', prevEl: '.prop-prev'},
      //pagination: true,
      autoplay:true,
      speed:700,
      effect:'slide',
      grabCursor: true,        
      loop: false,
      preloadImages: false,
      lazy: true,   
      breakpoints: {
        280: {
          slidesPerView: 1
        },
        600: {
          slidesPerView: 2
        },
        960: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 4
        }
      }
    }

    this.config4 = {
      observer: true,
      slidesPerView: 1,
      spaceBetween: 2,       
      keyboard: true,
      speed:500,
      effect:'flip',
      navigation: { nextEl: '.prop-next', prevEl: '.prop-prev'},
      //pagination: true,
      autoplay:true,
      grabCursor: true,        
      loop: false,
      preloadImages: false,
      lazy: true,   
      breakpoints: {
        280: {
          slidesPerView: 1
        },
        600: {
          slidesPerView: 1
        },
        960: {
          slidesPerView: 1
        },
        1280: {
          slidesPerView: 1
        }
      }
    }
    
  }

  public navigateModel(modelVoiture:any)
  {
    console.log(this.menuItems);
    let model=modelVoiture
    this.router.navigate([`model-voitures/${model}`]);
  }

}
